<app-dropdown [elevation]="3"
              [navigateEntriesWithArrowkeys]="true"
              [placement]="'bottom-end'">
  <button *dropdownTrigger
          class="btn btn-sm"
          type="button">
    <span class="user-select-none" style="font-family: '{{font?.name}}', sans-serif" aria-hidden="true">
      Aa
    </span>
    <span class="sr-only">Font selector</span>
    <fa-icon [icon]="['far', 'chevron-down']" class="text-muted ml-1 small"></fa-icon>
  </button>
  <div *dropdownPanel class="font-selector" role="menu">
    <button *ngFor="let font of Fonts"
            role="menuitem"
            type="button"
            class="btn"
            [class.active]="value === font.id"
            (click)="changeValue(font.id)"
            style="font-family: '{{font?.name}}', sans-serif"
       tabindex="0">
      <span aria-hidden="true">{{signatureText || font.name}}</span>
      <span class="sr-only">Font name: {{font.name}}</span>
    </button>
  </div>
</app-dropdown>
